/**
 * @generated SignedSource<<8c49b9f46676c46d04279e216b809e2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddCommentInput = {
  comment?: string | null | undefined;
  productId?: string | null | undefined;
  rating?: number | null | undefined;
};
export type AddCommentMutation$variables = {
  input: AddCommentInput;
};
export type AddCommentMutation$data = {
  readonly addComment: {
    readonly commentEdge: {
      readonly __typename: "CommentEdge";
      readonly node: {
        readonly comment: string | null | undefined;
        readonly createdAt: any | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
        readonly rating: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AddCommentMutation = {
  response: AddCommentMutation$data;
  variables: AddCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddCommentPayload",
    "kind": "LinkedField",
    "name": "addComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "commentEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "comment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rating",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2baa9302a3fd06b9f64a34e016b8331a",
    "id": null,
    "metadata": {},
    "name": "AddCommentMutation",
    "operationKind": "mutation",
    "text": "mutation AddCommentMutation(\n  $input: AddCommentInput!\n) {\n  addComment(input: $input) {\n    commentEdge {\n      __typename\n      node {\n        id\n        name\n        comment\n        rating\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af2ebba9a25bc56b62bb8380597b0050";

export default node;
